import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { useFiles } from "@/react/components/Spaces/CourseSpace/Shared/LessonFile/hooks/useFiles";
import { Uploader } from "@circle-react-shared/Uploader";
import { useToast } from "@circle-react-uikit/ToastV2";
import { useCompletedUploads } from "./useCompletedUploads";

export const useFileUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const { files, isLoading, meta, addFile, isAddingFile } = useFiles();
  const { completedUploads, addCompletedUpload } = useCompletedUploads();
  const toastr = useToast();

  const uploadProgress = progress => {
    setIsUploading(true);
    setProgress(progress);
  };

  const afterUpload = (itemUrl, signedId) => {
    addFile(signedId);
    setIsUploading(false);
    addCompletedUpload(signedId);
  };

  const handleUpload = event => {
    setProgress(0);
    setIsUploading(true);
    try {
      const uploader = new Uploader(
        event.target.files[0],
        afterUpload,
        "",
        "",
        uploadProgress,
      );
      uploader.start();
    } catch (e) {
      toastr.error(t("courses.edit.lesson.tabs.files.upload_error"));
    }
  };

  return {
    files,
    meta,
    progress,
    completedUploads,
    isLoading,
    isUploading,
    isAddingFile,
    handleUpload,
    afterUpload,
  };
};
